import get from "./get";
import remove from "./remove";
import set from "./set";

export default {
  get,
  remove,
  set
};
